import { useRef, useEffect, useState } from 'react';
import styles from './index.module.less';
import { ifHaveView } from '@/utils';

const getKey = (key) => <span className={styles.span}>「{key}」</span>;

const HeadTitle = ({ titleList = [], className }) => {
  const wrapperEle = useRef(null);
  const scrollEvent = useRef(null);
  const [canAnima, setCanAnima] = useState(false);
  useEffect(() => {
    window.removeEventListener('scroll', scrollEvent.current);
    if (!canAnima) {
      scrollEvent.current = () => {
        if (ifHaveView(wrapperEle.current)) {
          setCanAnima(true);
        }
      };
      scrollEvent.current();
      window.addEventListener('scroll', scrollEvent.current);
    }

    return () => {
      window.removeEventListener('scroll', scrollEvent.current);
    };
  }, [canAnima]);
  return (
    <div ref={wrapperEle} className={`${styles.wrapper} ${canAnima ? styles.transMoveUp : ''} ${className || ''}`}>
      {titleList.map((v) => {
        if (typeof v === 'string') {
          if (v.indexOf('#') === -1) {
            return <div key={v}>{v}</div>;
          }
          const startIndex = v.indexOf('#'); // 获取关键高亮初始
          const highKey = getKey(v.slice(startIndex + 1, startIndex + 3)); // 获取高亮span组件
          const tempV = v.replace(/#.+#/, '#'); // 将要替换的部分换成一个#
          const resultList = tempV.split('#'); // 通过#切割字符串为两部分
          resultList.splice(1, 0, highKey); // 在中间插入高亮部分
          return (
            <div key={v} className={startIndex === 0 ? styles.offset : undefined}>
              {resultList}
            </div>
          );
        }
        return null;
      })}
    </div>
  );
};

export default HeadTitle;
